import type { BulkMaterialUnitType } from '#domain/model/BulkMaterialUnitType.ts';

export const unitOptions: Array<{ id: BulkMaterialUnitType; label: string; selected?: boolean }> = [
    {
        id: 'cubic-meter',
        label: 'm3',
        selected: true,
    },
    {
        id: 'liter',
        label: 'l',
    },
    {
        id: 'kilogram',
        label: 'kg',
    },
    {
        id: 'ton',
        label: 't',
    },
];
